import {PhoneNumber} from "@/modules/models";

export default {
    start: {
        name: "start",
        path: "/v/start",
        title: "Startside",
        me: {
            name: "me",
            path: "/v/start/me",
            title: "Brukerinfo",
            registrations: {
                name: "me/registrations",
                path: "/v/start/me/registrations",
                title: "Mine registreringer"
            },
            appsettings: {
                name: "appsettings",
                path: "/v/start/me/appsettings",
                title: "App innstillinger"
            },
            regreminder: {
                name: "me/regreminder",
                path: "/v/start/me/regreminder",
                title: "Registreringspåminnelse"
            },
            notifications: {
                name: "notifications",
                path: "/v/start/me/notifications", // Also defined in Urls.scala
                title: "Varsling"
            },
        },
        card: {
            add: {
                path: "/v/start/card/add",
                title: "Legg til kort",
                qrinfo: {
                    path: "/v/start/card/add/qrinfo",
                    title: "Qr kode info"
                },
                qrReader: {
                    path: "/v/start/card/add/qr-reader",
                    title: "Qr kode leser"
                },
                pending: {
                    name: "pendingCard",
                    path: "/v/start/card/add/pending/:cardNum",
                    title: "Bekreft korttilknytning"
                }
            },
        }
    },
    locations: {
        name: "locations",
        path: "/v/locations",
        title: "Anlegg",
        location: {
            name: "location",
            path: `/v/locations/:locationId`,
            title: `Anlegg`,
            paramPath: (locationId: number) => `/v/locations/${locationId}`,
            onsite: {
                path: "/v/locations/:locationId/onsite",
                title: "Innregistrert nå",
                paramPath: (locationId: number) => `/v/locations/${locationId}/onsite`,
            },
            poster: {
                name: "location/poster",
                path: "/v/locations/:locationId/poster",
                title: "Anleggsplakat"
            },
            confirmedHseGuidelineReport: {
                name: "location/hseguideline/confirmed",
                path: "/v/locations/:locationId/confirmed-hse-guideline",
                title: "Bekreftelsesrapport HMS retningslinje"
            }
        },
        setup: {
            name: "locations/setup",
            path: "/v/locations/setup",
            title: "Opprett nytt"
        }
    },
    registrations: {
        name: "registrations",
        path: "/v/registrations",
        title: "Registreringer"
    },
    terminals: {
        name: "terminals",
        path: "/v/terminals",
        title: "Kortlesere",
        terminal: {
            name: "terminal",
            path: "/v/terminals/:guid",
            title: "Kortleser",
            paramPath: (guid: string) => `/v/terminals/${guid}`,
            disconnectAlarm: {
                name: "terminalDisconnectAlarm",
                path: "/v/terminals/:guid/disconnect-alarm",
                title: "Frakoblingsalarm"
            }
        },
        pending: {
            name: "pendingTerminal",
            path: "/v/terminals/pending/:guid",
            title: "Ventende kortleseroppsett"
        },
    },
    shop: {
        name: "shop",
        path: "/v/shop",
        title: "Butikk",
        order: {
            name: "shop/order",
            path: "/v/shop/orders/order/:id",
            title: "Bestilling",
        },
        orders: {
            name: "shop/orders",
            path: "/v/shop/orders",
            title: "Bestillinger",
        }
    },
    system: {
        name: "system",
        path: "/v/system",
        title: "Systemadministrasjon",
        integrations: {
            name: "integrations",
            path: "/v/system/integrations",
            title: "Integrasjoner",
            hmsreg: {
                name: "hmsreg",
                path: "/v/system/integrations/hmsreg",
                title: "HMSREG",
            },
            proresult: {
                name: "system/integrations/proresult",
                path: "/v/system/integrations/proresult",
                title: "ProResult"
            },
            exportservice: {
                name: "system/integrations/exportservice",
                path: "/v/system/integrations/exportservice",
                title: "Eksportservice"
            }
        },
        billing: {
            name: "billing",
            path: "/v/system/billing",
            title: "Fakturering"
        },
        hseguidelines: {
            name: "hseguidelines",
            path: "/v/system/hseguidelines",
            title: "HMS retningslinjer",
        },
    },
    docs: {
        name: "docs",
        path: "/docs",
        title: "Dokumentasjon",
        intro: {
            path: "/docs/intro",
            title: "Introduksjon",
            locationsetup: {
                path: "/docs/intro/locationsetup",
                title: "Konfigurasjon av anlegg"
            }
        },
        adminintro: {
            path: "/docs/admin-intro",
            title: "Administratorintroduksjon",
        },
        roleinfo: {
            path: "/docs/roleinfo",
            title: "Rolleinformasjon"
        },
        priceinfo: {
            path: "/docs/priceinfo",
            title: "Prisinfo"
        },
        iphonewebreset: {
            path: "/docs/iphone-web-reset",
            title: "Iphone: posisjon blokkert"
        },
        regreminder: {
            path: "/docs/regreminder",
            title: "Registreringspåminnelse"
        },
        newcard: {
            path: "/docs/newcard",
            title: "Nytt hmskort"
        },
        notifications: {
            path: "/docs/notifications",
            title: "Varslinger"
        },
        hseguidelines: {
            path: "/docs/hseguidelines",
            title: "HMS retningslinjer"
        },
        infectiontrace: {
            path: "/docs/infectiontrace",
            title: "Smittesporing"
        },
        terminal: {
            path: "/docs/terminal",
            title: "Kortleser",
            reactivation: {
                path: "/docs/terminal/reactivation",
                title: "Reaktivering"
            },
            networksetup: {
                path: "/docs/terminal/networksetup",
                title: "Nettverksoppsett"
            },
            nocardread: {
                path: "/docs/terminal/no-card-read",
                title: "Kortlesing fungerer ikke"
            }
        }
    },
    company: {
        name: "company",
        path: "/v/company",
        title: "Firma",
        q: (orgnum: number | null = null, redir: string | null = null) => ({orgnum: `${orgnum ? orgnum : ""}`, redir: redir || ""}),
        init: {
            name: "company/init",
            path: "/v/company/init",
            title: "Opprett firmakonto",
        }
    },
    users: {
        name: "users",
        path: "/v/users",
        title: "Brukere",
        add: {
            name: "users/add",
            path: "/v/users/add",
            title: "Ny bruker"
        },
        reports: {
            path: "/v/users/reports",
            title: "Bruker-rapporter",
            phonelist: {
                path: "/v/users/reports/phonelist",
                title: "Telefonliste"
            },
            allusers: {
                path: "/v/users/reports/allusers",
                title: "Alle brukere"
            },
            roles: {
                path: "/v/users/reports/roles",
                title: "Tildelt roller"
            },
            cardexpiration: {
                path: "/v/users/reports/cardexpiration",
            },
            cardexpirationlocation: {
                path: "/v/users/reports/cardexpiration-locations", // Also defined in NotificationActor.scala
                title: "Kortutløpskontroll egne anlegg",
            },
            cardexpirationcompany: {
                path: "/v/users/reports/cardexpiration-company", // Also defined in NotificationActor.scala
                title: "Kortutløpskontroll egne HMS-kort",
            },
            withoutCard: {
                path: "/v/users/reports/without-card",
                title: "Mangler kort"
            },
            infectiontrace: {
                name: "infectiontrace",
                path: "/v/users/reports/infectiontrace",
                title: "Smittesporing",
            },
            withoutPhone: {
                name: "reports/without-phone",
                path: "/v/users/reports/without-phone",
                title: "Mangler mobilnummer"
            }
        }
    },
    usermessages: {
        name: "user-messages",
        path: "/v/user-messages",
        title: "Systemmeldinger"
    },
    super: {
        name: "super",
        path: "/v/super",
        title: "Super",
        sims: {
            name: "super/sims",
            path: "/v/super/sims",
            title: "Simkort"
        },
        simsDetail: {
            name: "super/sims-detail",
            path: "/v/super/sims/:section(com4|manual|without-sim|legacy)",
            title: "SIM-oppfølging"
        },
        companyMigrate: {
            name: "super/company-migrate",
            path: "/v/super/company-migrate",
            title: "Flytt firma data"
        },
        usagestats: {
            name: "usagestats",
            path: "/v/super/usagestats",
            title: "Bruks-statistikk"
        },
        terminalDataUsage: {
            name: "terminal-data-usage",
            path: "/v/super/terminal/:guid/data-usage",
            title: "Kortleser databruk"
        }
    },
    unauthorized: {
        name: "unauthorized",
        path: "/v/unauthorized",
        title: "Ikke autorisert"
    },
    login: {
        name: "login",
        path: "/login",
        title: "Innlogging",
        q: (redir: string | null = null) => ({redir: redir || ""}),
        missing: {
            name: "login/missing",
            path: "/login/missing",
            title: "Mobilnummer",
            q: (phone?: PhoneNumber | null, signup?: boolean) => ({phone: phone ? phone.toString() : "", signup: signup || false}),
        },
        keylogin: {
            name: "keylogin",
            path: "/login/key",
            title: "Nøkkelinnlogging"
        },
        signupunverified: {
            name: "signupunverified",
            path: "/login/signup/unverified",
            title: "Ny bruker"
        },
        checked: {
            name: "checked",
            path: "/login/checked/phone/:countrycode/:number",
            title: "Kontrollert"
        },
        signup: {
            name: "signup",
            path: "/login/signup/:countrycode/:number",
            title: "Ny bruker",
            qr: {
                name: "signupqr",
                path: "/login/signup/:countrycode/:number/qr",
                title: "QR",
                info: {
                    name: "qrinfo",
                    path: "/login/signup/:countrycode/:number/qr/info",
                    title: "Info"
                }
            },
            verified: {
                name: "signupverified",
                path: "/login/signup/:countrycode/:number/card/:cardnum",
                title: "Bekreft kortinfo"
            }
        },
        config: {
            name: "config",
            path: "/login/config",
            title: "App innloggingskonfigurasjon",
        },
    },
    about: {
        name: "about",
        path: "/about",
        title: "Om Anleggsterminal",
        privacypolicy: {
            name: "privacypolicy",
            path: "/about/privacy/policy",
            title: "Privacy policy"
        },
        userterms: {
            name: "userterms",
            path: "/about/terms/user",
            title: "Brukervilkår",
        }
    },
    public: {
        name: "public",
        path: "/public",
        title: "Velkommen",
        signup: {
            name: "public/signup",
            path: "/public/signup",
            title: "Bli kunde",
        },
        emailConfirm: {
            name: "email-confirm",
            path: "/public/email-confirm/:secret",
            title: "Bekreft epost tilknytning"
        },
        videos: {
            name: "videos",
            path: "/public/videos",
            title: "Anleggsterminal videoer"
        },
        recaptcha: {
            name: "recaptcha-check",
            path: "/public/recaptcha-check",
            title: "Recaptcha kontroll"
        }
    }
};

